export default __webpack_public_path__ + "static/media/@jesstolledoo.99be8cee.jpg";